import HeroHeading from '../../../components/Headings/HeroHeading'
import HeroDescription from '../../../components/Headings/HeroDescription'
import BookACallButton from '../../Buttons/Specials/BookACallButton'
import Badge from '../../HomePage/Badge'
import HomepageBookCallLeadModal from '../../Modals/HomepageBookCallLeadModal'

const NEW_OFFER_MODAL_PROPS = {
    meetingTitle: 'Book a Coaching Call',
    formName: 'First Time Client Offer Strategy Call',
}

const Hero = () => {
    return (
        <div className="bg-light-yellow-gradient-transparent">
            <div className='md:bg-[url("/assets/landing/new-offer/left.svg")] bg-left bg-no-repeat'>
                <div className='md:bg-[url("/assets/landing/new-offer/right.svg")] bg-right bg-no-repeat flex py-16 px-2 sm:px-6 lg:pt-24 pb-0 lg:px-8'>
                    <div className="flex relative flex-col lg:flex-row max-w-7xl m-auto">
                        <div className="max-w-5xl mx-auto text-center md:space-y-4 space-y-10 flex-1">
                            <HeroHeading>
                                <div className="space-y-2 space-x-1 hidden md:block">
                                    <p>Get Started with Direct Mail for Just</p>
                                    <span className="olm-gradient-text">
                                        $0.53 Per Postcard + 1,500 FREE Leads
                                    </span>
                                    <span>!</span>
                                </div>
                                <div className="space-y-2 space-x-2 md:hidden">
                                    <span>
                                        Get Started with Direct Mail for Just
                                    </span>
                                    <br />
                                    <span className="olm-gradient-text">
                                        $0.53 Per Postcard + 1,500 FREE Leads{' '}
                                        {''}
                                    </span>
                                    !
                                </div>
                            </HeroHeading>
                            <HeroDescription>
                                <div className="max-w-xl m-auto font-semibold capitalize">
                                    This offer is exclusively available to
                                    first-time customers <br /> and applies only
                                    to your first order.
                                </div>
                            </HeroDescription>
                            <div className="max-w-4xl w-full m-auto space-y-6">
                                <div className="max-w-md w-full m-auto pb-6">
                                    <BookACallButton
                                        Modal={HomepageBookCallLeadModal}
                                        modalProps={NEW_OFFER_MODAL_PROPS}>
                                        Book A Call To Lock in Your Rates Today!
                                    </BookACallButton>
                                </div>

                                <p className="space-y-2">
                                    <p className="font-semibold">
                                        Repeat orders or existing customer
                                        accounts are not eligible for this
                                        promotion.
                                    </p>
                                </p>
                                <div className="py-10">
                                    <Badge hasHeading={false} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Hero
